/** Rules the API (zod) and the web forms must agree on: if the phone queues a value the server
 *  rejects, the outbox parks the op as "failed" and the change vanishes after the next sync. */

/** Email shape accepted for leads — the same pattern as zod 4's default `z.email()`. */
export const EMAIL_PATTERN =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;

/** Calendar date YYYY-MM-DD (D5). Desktop date inputs allow 5–6 digit years, which the API rejects. */
export const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
